import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import { ICalendarState } from "source/app/presentation/MainPanel/Calendar/ICalendarState";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export async function GetSimplifiedEvents(): Promise<ICalendarEvent[]> {
    const calendar = State.ReadClass<ICalendarState>(ESharedComponent.Calendar);

    if (!calendar) {
        return [];
    }

    let events: ICalendarEvent[] = [];

    try {
        events = await MotwLogicServer.GetSimplifiedCalendarEvents();

        if (!Array.isArray(events)) {
            throw new Error(`Calendar events response was not an array`);
        }

        if (events.length === 0) {
            console.warn(`No calendar events found`);
        }

        const didCalendarHaveErrorLoadingData =
            calendar.state.hasErrorLoadingData;

        if (didCalendarHaveErrorLoadingData) {
            calendar.setState({ hasErrorLoadingData: false });
        }

        return events;
    } catch (e) {
        calendar.setState({ hasErrorLoadingData: true }, () => {
            console.error(e);
        });

        return [];
    } finally {
        calendar.setState({ isLoading: false });
    }
}
